import * as React from "react";
const SVGComponent = (props) => (
    <svg width={15} height={16} viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M13.712 3.172a1.94 1.94 0 0 1-1.936 1.945A1.94 1.94 0 0 1 9.84 3.172a1.94 1.94 0 0 1 1.936-1.944 1.94 1.94 0 0 1 1.936 1.944Zm0 9.918a1.94 1.94 0 0 1-1.936 1.944 1.94 1.94 0 0 1-1.936-1.945 1.94 1.94 0 0 1 1.936-1.944 1.94 1.94 0 0 1 1.936 1.944Zm-8.65-4.96a1.94 1.94 0 0 1-1.936 1.943A1.94 1.94 0 0 1 1.189 8.13a1.94 1.94 0 0 1 1.937-1.944A1.94 1.94 0 0 1 5.062 8.13Z"
            stroke="#001659"
            strokeWidth={1.07}
        />
        <path transform="rotate(-32.086 15.55 -4.908)skewX(-.16)" stroke="#001659" strokeWidth={1.07} d="M0-.535h5.834" />
        <path transform="matrix(.84726 .53119 .52881 -.84874 4.982 8.75)" stroke="#001659" strokeWidth={1.07} d="M0-.535h5.834" />
    </svg>
);
export default SVGComponent;
